// extracted by mini-css-extract-plugin
export default {"mainCont":"PassChange_mainCont__neCIg","title":"PassChange_title__XgDTK","lnRow":"PassChange_lnRow__GlyC2","btnCont":"PassChange_btnCont__oWyfp"};